import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";

// Storage shim so the existing app's `window.storage.get/set/remove` calls keep working.
// Future: replace per-feature with Supabase queries.
window.storage = {
  get: async (key) => {
    const v = localStorage.getItem(key);
    return v == null ? null : { value: v };
  },
  set: async (key, value) => { localStorage.setItem(key, value); },
  remove: async (key) => { localStorage.removeItem(key); },
};

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
